import { useCallback, useState } from 'react';
import { apiErrorMessage } from '../utils/apiErrorMessage';

/**
 * The step 4 → 5 hand-off. Whatever the wizard does on "Continue to quotes"
 * may be async and may fail; the button shows it is busy, and a failure is
 * said out loud instead of leaving the buyer on a button that did nothing.
 */
export const useOutreachContinue = (onNext: () => void | Promise<void>) => {
  const [isContinuing, setIsContinuing] = useState(false);
  const [continueError, setContinueError] = useState<string | null>(null);

  const handleContinue = useCallback(async () => {
    setContinueError(null);
    setIsContinuing(true);
    try {
      await onNext();
    } catch (error: unknown) {
      setContinueError(apiErrorMessage(error, 'Your threads are safe here — try again.'));
    } finally {
      setIsContinuing(false);
    }
  }, [onNext]);

  return {
    handleContinue,
    isContinuing,
    continueError,
    dismissContinueError: useCallback(() => setContinueError(null), []),
  };
};
